import { EvergreenCommunityListingAvailability } from "@sp-crm/core";
import * as React from "react";
import { Checkbox } from "../../ui/checkbox";
import { ISearchFilterClosable } from "./search-filter-closable.interface";
import { SearchFilterProps } from "./search-filter-props.interface";

interface SearchAvailabilityProps {
    availability?: EvergreenCommunityListingAvailability[];
}

interface SearchAvailabilityState {
    availability: EvergreenCommunityListingAvailability[];
}

type SearchAvailabilityFilterProps = SearchAvailabilityProps & SearchFilterProps;

export class SearchAvailability
    extends React.Component<SearchAvailabilityFilterProps, SearchAvailabilityState>
    implements ISearchFilterClosable
{
    DEFAULT_VALUE: EvergreenCommunityListingAvailability[] = [];

    constructor(props: SearchAvailabilityFilterProps) {
        super(props);
        this.state = {
            availability: props.availability || [],
        };

        this.onClose = this.onClose.bind(this);
        this.onAvailabilityChanged = this.onAvailabilityChanged.bind(this);
    }

    onClose() {
        this.props.onClose({
            activeState: {
                availability: this.state.availability,
            },
            defaultState: {
                availability: this.DEFAULT_VALUE,
            },
        });
    }

    onValid() {
        this.props.onValid(true);
    }

    UNSAFE_componentWillMount() {
        this.onValid();
    }

    componentWillUnmount() {
        this.onClose();
    }

    onAvailabilityChanged(availability: EvergreenCommunityListingAvailability) {
        const currentAvailability = this.state.availability;
        const isSelected = currentAvailability.includes(availability);

        if (isSelected) {
            this.setState({
                availability: currentAvailability.filter(a => a !== availability),
            });
        } else {
            this.setState({
                availability: [...currentAvailability, availability],
            });
        }
    }

    render() {
        return (
            <div className="search-availability-component min-w-60">
                <h3 className="text-base font-semibold mb-3">Vacancy Status</h3>
                <div className="space-y-1">
                    <Checkbox
                        name="availability"
                        value={EvergreenCommunityListingAvailability.Available}
                        checked={this.state.availability.includes(
                            EvergreenCommunityListingAvailability.Available,
                        )}
                        onChange={() =>
                            this.onAvailabilityChanged(
                                EvergreenCommunityListingAvailability.Available,
                            )
                        }
                        label="Available"
                        labelClassName="text-sm"
                    />
                    <Checkbox
                        name="availability"
                        value={EvergreenCommunityListingAvailability.Unavailable}
                        checked={this.state.availability.includes(
                            EvergreenCommunityListingAvailability.Unavailable,
                        )}
                        onChange={() =>
                            this.onAvailabilityChanged(
                                EvergreenCommunityListingAvailability.Unavailable,
                            )
                        }
                        label="Unavailable"
                        labelClassName="text-sm"
                    />
                    <Checkbox
                        name="availability"
                        value={EvergreenCommunityListingAvailability.Unknown}
                        checked={this.state.availability.includes(
                            EvergreenCommunityListingAvailability.Unknown,
                        )}
                        onChange={() =>
                            this.onAvailabilityChanged(
                                EvergreenCommunityListingAvailability.Unknown,
                            )
                        }
                        label="Unknown"
                        labelClassName="text-sm"
                    />
                </div>
            </div>
        );
    }
}
